import Button from "material-ui/FlatButton"
import RefreshIcon from "material-ui/svg-icons/action/system-update-alt"
import React from "react"
import * as Util from "../common"
import {containers} from "@swarm2/core"

const M = Util.intlMessages("view.ReleaseCountdown")

function ReleaseCountdownRender(props) {
  const {url, releaseCountdown, sinceRelease, isReleased, error} = props
  if (error || !releaseCountdown) return null
  return (
    <Button
      icon={<RefreshIcon />}
      target="_blank"
      href={url}
      label={
        isReleased ? (
          <M id="over" />
        ) : (
          <M
            id="counting"
            values={{
              countdown: (
                <Util.Duration
                  millis={sinceRelease}
                  noSuffix
                  format="countdown"
                />
              ),
            }}
          />
        )
      }
    />
  )
}

export default containers.updateWatcher.ReleaseCountdown(ReleaseCountdownRender)



// WEBPACK FOOTER //
// ./src/updates/ReleaseCountdown.js